import script from "./QuotaUsage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotaUsage.vue?vue&type=script&setup=true&lang=ts"

import "./QuotaUsage.vue?vue&type=style&index=0&id=51f110d1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51f110d1"]])

export default __exports__